import { render, staticRenderFns } from "./StaffGroupProfile.vue?vue&type=template&id=2618c09f&scoped=true"
import script from "./StaffGroupProfile.vue?vue&type=script&lang=js"
export * from "./StaffGroupProfile.vue?vue&type=script&lang=js"
import style0 from "./StaffGroupProfile.vue?vue&type=style&index=0&id=2618c09f&prod&scoped=true&lang=css"
import style1 from "./StaffGroupProfile.vue?vue&type=style&index=1&id=2618c09f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2618c09f",
  null
  
)

export default component.exports